export function stages() {

    const stagesBulletsItem = document.querySelectorAll('.js-stagesBulletsItem');
    const stagesResultList = document.querySelectorAll('.js-stagesResultList');
    const stagesResultTitle = document.querySelector('.js-stagesResultTitle');

    stagesBulletsItem.forEach( function(item) {
        item.addEventListener('click', function() {
            let bulletNum = 0;
            for (let i = 0; i < this.parentElement.children.length; ++i) {
                if (this.parentElement.children[i] == this) {
                    bulletNum = i + 1;
                    break;
                }
            }

            stagesBulletsItem.forEach(function(elem, index) {
                elem.classList.remove('is-prev');
                elem.classList.remove('is-active');

                if (index == bulletNum - 1) {
                    elem.classList.add('is-active');
                } else if (index < bulletNum) {
                    elem.classList.add('is-prev');
                }
            });

            stagesResultList.forEach(function(elem, index) {
                elem.classList.remove('is-active');

                 if (index == bulletNum - 1) {
                    elem.classList.add('is-active');
                    stagesResultTitle.textContent = elem.dataset.title;
                 }
            });

            if (window.innerWidth < 570) {
                let visibleBullets = Math.round(window.innerWidth / 105),
                    finishPosition = 570 - window.innerWidth;

                if (visibleBullets == bulletNum) {
                    item.parentNode.style.transform = `translateX(-${finishPosition / 2.5}px)`;

                } else if (bulletNum == visibleBullets + 1) {

                    if (visibleBullets + 1 == 5) {
                        item.parentNode.style.transform = `translateX(-${finishPosition}px)`;
                    } else {
                        item.parentNode.style.transform = `translateX(-${finishPosition - (finishPosition / (visibleBullets + 1))}px)`;
                    }

                } else if (visibleBullets < bulletNum && bulletNum != visibleBullets + 1) {
                    item.parentNode.style.transform = `translateX(-${finishPosition}px)`;

                } else if (visibleBullets > bulletNum) {
                    item.parentNode.style.transform = ``;

                }
            }
        });
    });
}
